export const LAST_VALID_ROUTE = 'LAST_VALID_ROUTE';

export const SessionManager = {
  setLastValidRoute: (route) => {
    // console.warn('Setting Valid Route', route);
    localStorage.setItem(LAST_VALID_ROUTE, route);
  },
  getLastValidRoute: () => {
    return localStorage.getItem(LAST_VALID_ROUTE);
  }
}